import React, { useEffect, useState, startTransition } from 'react';

import bookingService from 'components/Booking-new/services/BookingService';
import { setBooking, setIsError } from 'components/Booking-new/actions';
import useSelector, { useDispatch } from 'components/Booking-new/hooks';
import Loader from 'components/Booking-new/modules/Steps/shared/Loader';
import stepTypes from 'components/Booking-new/modules/Steps/types';
import { getServiceCode } from 'components/Booking-new/utils/steps/service';
import { getBookingData, pushAppointmentBookedTracking } from 'components/Booking-new/utils/steps/summary';
import { getVisitsOnLocalStorage } from '../../../../../utils/bas/getVisitsOnLocalStorage';
import { refreshToken } from '../../../utils/helpers/refreshToken';
import getURLParameter from '../../../../../utils/getURLParams';
import { getCookie } from '../../../../../utils/cookies';

const SummaryContainer = (Component, { data }) => {
  const [isSummaryReady, setIsSummaryReady] = useState(false);
  const dispatch = useDispatch();
  const { results, state } = useSelector(state => ({
    stepLocationData: state?.userData[stepTypes.location]?.selectedLocation,
    stepTimeData: state?.userData[stepTypes.time],
    stepPersonalData: state?.userData[stepTypes.personalData],
    rescheduleData: state?.userData[stepTypes.reschedule]?.appointment?.appointmentid,
    serviceCode: getServiceCode(state?.userData[stepTypes.reschedule]?.service.service, state?.config?.service?.code),
    funnelType: state?.config?.funnelType,
  }));

  const { serviceCode, funnelType } = results;

  useEffect(() => {
    const saveBooking = async () => {
      const stateConfig = { ...state.config, service: { ...state.config.service, code: serviceCode } };
      const body = getBookingData({
        ...state,
        config: stateConfig,
      });

      let additionalBodyProps = {};
      if (body.saction === 'RESCH') additionalBodyProps.change_source = getURLParameter('change-source');
      const visits = [];
      getVisitsOnLocalStorage(visits);
      function getOrInitializeConsent(name) {
        const value = getCookie(name);
        return value === 'true'; // `true` if cookie value is 'true', otherwise `false`
      }
      const consent_facebook_pixel = getOrInitializeConsent('consent_facebook_pixel');
      const consent_google_ads = getOrInitializeConsent('consent_google_ads');
      const consent_google_analytics_4 = getOrInitializeConsent('consent_google_analytics_4');
      const consent_tiktok_advertising = getOrInitializeConsent('consent_tiktok_advertising');
      if (localStorage.getItem('user-anom-id')) additionalBodyProps.anom_id = localStorage.getItem('user-anom-id');
      if (visits.length > 0) additionalBodyProps.visits = visits;
      additionalBodyProps.consent_facebook_pixel = consent_facebook_pixel;
      additionalBodyProps.consent_google_ads = consent_google_ads;
      additionalBodyProps.consent_google_analytics_4 = consent_google_analytics_4;
      additionalBodyProps.consent_tiktok_advertising = consent_tiktok_advertising;
      const extendedBody = { ...body, ...additionalBodyProps };

      const newToken = await refreshToken();

      const { data: bookingData, error } = await bookingService.saveBooking({ ...extendedBody }, newToken);

      if (!error) {
        pushAppointmentBookedTracking({ ...results, service: serviceCode, funnelType }, bookingData);
        startTransition(() => {
          dispatch(setBooking(bookingData));
          setIsSummaryReady(true);
        });
        return;
      }

      dispatch(setIsError(true));
    };

    saveBooking();
  }, []);

  if (!isSummaryReady) return <Loader />;

  return <Component data={data} />;
};

export default SummaryContainer;
